<template>
  <v-dialog v-model="show" class="modal" persistent max-width="500px" scrollable>
    <v-card style="overflow-y: auto">
      <v-container>
        <v-layout>
          <v-flex>
            <v-card-title primary-title class="pl-0">
              <span class="attendee-field-title">
                {{ headerText }}
              </span>
            </v-card-title>
            <div class="mb-22 attendee-field-description">Choose type of attendee field</div>
          </v-flex>
          <v-flex style="text-align: end; padding-top: 16px">
            <v-btn icon @click="closeDialog">
              <v-icon color="#979797">clear</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout v-if="attendeesExist && action === 'update'" align-center class="error-container">
          <span class="error-message"> Cannot change fields because attendees already exist. </span>
        </v-layout>
        <attendee-field-form
          v-if="show"
          :vs="$v"
          :initial-values="form"
          :fields="fields"
          :attendees-exist="attendeesExist"
          :action="action"
          @values="form = $event"
        />
      </v-container>
      <div class="buttons-container">
        <main-button
          v-if="!attendeesExist"
          class="action-button"
          color="error"
          flat
          text="Delete"
          @click="emitDelete"
        />
        <main-button
          depressed
          class="action-button"
          :text="okText"
          :disabled="action === 'update' ? attendeesExist : false"
          @click="submitForm"
        />
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators'

import AttendeeFieldForm from './attendee-field-form.vue'
import { notIn } from '../../validators'

export default {
  name: 'attendee-field-dialog',
  components: {
    AttendeeFieldForm,
  },
  props: {
    show: Boolean,
    deletable: Boolean,
    action: {
      type: String,
      validator: value => ['add', 'update'].indexOf(value) !== -1,
    },
    attendeesExist: Boolean,
    fields: {
      type: Array,
      default: () => [],
    },
    field: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: this.field,
    }
  },
  computed: {
    headerText() {
      return this.action === 'add' ? 'New attendee field' : 'Update attendee field'
    },
    okText() {
      return this.action === 'add' ? 'Save' : 'Update'
    },
  },
  watch: {
    field: {
      handler(val) {
        this.form = val
      },
    },
  },
  validations() {
    return {
      form: {
        name: {
          required,
          notIn: notIn(
            this.fields.map(f => f.name),
            this.field.name,
          ),
          maxLength: maxLength(80),
        },
        value: {
          component: {
            required,
          },
        },
      },
    }
  },
  methods: {
    async submitForm() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        if (this.form.value.items) {
          this.form.value.items = this.form.value.items.filter(item => item !== '')
        }
        const { value, ...rest } = this.form
        const validations = value.validations
        if (!value.type) {
          value.type = 'text'
        }
        if (this.attendeesExist) {
          this.$emit('submit', {
            ...rest,
            ...value,
            validations: { ...validations, required: false },
          })
        } else {
          this.$emit('submit', { ...rest, ...value, ...validations })
        }
        this.closeDialog()
      }
    },
    emitDelete() {
      const { id } = this.form
      if (id) {
        this.$emit('delete', id)
        this.closeDialog()
      }
    },
    closeDialog() {
      this.form = { validations: {} }
      this.$v.$reset()
      this.$emit('update:show', false)
    },
  },
}
</script>

<style scoped>
::v-deep .v-dialog--scrollable {
  background-color: #fff;
}
.action-button {
  margin: 0 0 16px 24px !important;
  width: 94px !important;
  height: 36px !important;
}
.container {
  padding: 0 32px;
}
.error-message {
  width: 100%;
  background-color: #f3263e6b;
  padding-left: 42px;
}
.error-container {
  padding-bottom: 16px;
}
.attendee-field-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 1.25rem;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #0277bd;
}
.attendee-field-description {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 1rem;
  color: #979797;
}
.buttons-container {
  display: flex;
  justify-content: flex-end;
  padding-right: 30px;
}
</style>
